import { render, staticRenderFns } from "./CreateMandate.vue?vue&type=template&id=b393012e&scoped=true&"
import script from "./CreateMandate.vue?vue&type=script&lang=ts&"
export * from "./CreateMandate.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMandate.vue?vue&type=style&index=0&id=b393012e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b393012e",
  null
  
)

export default component.exports